import { Flags, EventListener } from '../model'

export default class BaseSource {
  eventListener?: EventListener

  update(flags: Flags) {
    if (this.eventListener) {
      this.eventListener(flags)
    }
  }

  onUpdate(eventListener: EventListener) {
    this.eventListener = eventListener
  }
}
